export enum SettingsTab {
  GENERAL,
  NOTIFICATIONS,
}

export const SettingsTabsCollection: Record<SettingsTab, TabDefinition> = {
  [SettingsTab.GENERAL]: {
    label: 'General',
    subPath: 'general',
  },
  [SettingsTab.NOTIFICATIONS]: {
    label: 'Notifications',
    subPath: 'notifications',
  },
};

export const getTabIndex = (path: string): number => {
  const idx = Object.values(SettingsTabsCollection).findIndex(
    ({ subPath }: TabDefinition) => subPath === path,
  );
  return Math.max(idx, SettingsTab.GENERAL);
};
